import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import useUserStore from '../../../store/user-store';
import Loader from './Loader';

const ProtectedRoute = ({ children }) => {
  const user = useUserStore((state) => state.user);
  const authReady = useUserStore((state) => state.authReady);
  const bootstrapSession = useUserStore((state) => state.bootstrapSession);
  const location = useLocation();

  useEffect(() => {
    if (!authReady) {
      bootstrapSession();
    }
  }, [authReady, bootstrapSession]);

  if (!authReady) {
    return <Loader className="flex justify-center items-center h-[60vh]" />;
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return children;
};

export default ProtectedRoute;
